import React from 'react'
import { CARD_DEFS } from '../cards/registry'
import type { CardType } from '../types/LessonDoc'

// Bảng thẻ KÉO ĐƯỢC: kéo chip thả vào một phần ở giữa, hoặc bấm để thêm vào phần đang chọn.
const DraggablePalette: React.FC<{ onAdd: (type: CardType) => void }> = ({ onAdd }) => {
  return (
    <div className="space-y-2">
      <h3 className="text-xs font-black text-gray-400 uppercase tracking-wider mb-1">Kho thẻ (kéo vào phần)</h3>
      <div className="grid grid-cols-1 gap-2">
        {CARD_DEFS.map((def) => {
          const Icon = def.icon
          return (
            <div
              key={def.type}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData('text/card-new', def.type)
                e.dataTransfer.effectAllowed = 'copy'
              }}
              onClick={() => onAdd(def.type)}
              title="Kéo vào một phần, hoặc bấm để thêm vào phần đang chọn"
              className="flex items-center gap-3 p-2.5 rounded-xl border border-gray-100 bg-white hover:border-blue-200 hover:bg-blue-50/40 transition-all cursor-grab active:cursor-grabbing select-none"
            >
              <span className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${def.color}`}>
                <Icon size={18} />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-bold text-gray-800">{def.label}</span>
                <span className="block text-[11px] text-gray-400 truncate">{def.description}</span>
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DraggablePalette
